import React from 'react';
import PropTypes from 'prop-types';
import { constants } from '@wsb/guac-widget-core';
import { appendChowNowScript } from '../helpers';

const { PUBLISH, PREVIEW } = constants.renderModes;

class ChowNowScript extends React.Component {
  constructor() {
    super(...arguments);
  }

  componentDidMount() {
    this.appendScript();
  }

  // Need to remove the ChowNow script in EDIT mode
  // so that the data-route works
  componentWillMount() {
    if (!this.previewOrPublishRenderMode(this.props.renderMode)) {
      this.removeChowNow();
    }
  }

  removeChowNow() {
    var scripts = document.getElementsByClassName('gc-chownow-script');
    Array.prototype.forEach.call(scripts, function (script) {
      script.parentNode.removeChild(script);
    });
    var containers = document.getElementsByClassName('chownow-container');
    Array.prototype.forEach.call(containers, function (container) {
      container.parentNode.removeChild(container);
    });
  }

  appendScript() {
    const { externalId, renderMode } = this.props;

    var scripts = document.getElementsByClassName('gc-chownow-script');
    if (scripts.length > 0) {
      return;
    }

    const externalIdDefined = !!externalId;
    if (!(externalIdDefined && this.previewOrPublishRenderMode(renderMode))) {
      return;
    }

    appendChowNowScript(externalId);
  }

  previewOrPublishRenderMode(renderMode) {
    return renderMode === PUBLISH || renderMode === PREVIEW;
  }

  render() {
    return null;
  }
}

ChowNowScript.propTypes = {
  externalId: PropTypes.string,
  renderMode: PropTypes.string.isRequired
};

export default ChowNowScript;
